module.exports = __webpack_public_path__ + "fonts/remixicon.3e53d60e.woff2";